import { connect } from 'react-redux';
import OptionButton from './OptionButton';

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OptionButton);



// WEBPACK FOOTER //
// ./src/components/OptionButton/index.js